import TicketsPanel from "@/components/TicketsPanel";
export default function ClientTickets() {
  return <div className="px-5 py-6"><TicketsPanel isClient={true} /></div>;
}
